module.exports = __webpack_public_path__ + "img/triangle.decd3807.svg";